module.exports = __webpack_public_path__ + "img/plus_btn.264e782b.png";